import { QueryKey } from "@tanstack/react-query";

export const onboardingSettings = {
  all: () => ["onboardingSettings"] as QueryKey,
};
